import { render } from "./ActualCarCard.vue?vue&type=template&id=082a98c0&scoped=true"
import script from "./ActualCarCard.vue?vue&type=script&lang=js"
export * from "./ActualCarCard.vue?vue&type=script&lang=js"

import "./ActualCarCard.vue?vue&type=style&index=0&id=082a98c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082a98c0"]])

export default __exports__